import React, { ReactElement, useContext } from 'react'

import { Button, Text, TextProps } from '@hhgtech/hhg-components/mantine'
import { Close } from '@hhgtech/icons/core'
import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import { AIChatBotContext } from '../../context'
import { AvatarFocus } from '../avatarFocus'

type Props = {
  headingTag?: ReactElement<TextProps>
  onClose?: () => void
} & BoxProps

export const ConversationHeader = ({
  headingTag = <Text />,
  styles,
  classNames,
  className,
  onClose,
  ...boxProps
}: Props) => {
  const { name } = useContext(AIChatBotContext)
  const { classes, cx } = useStyles(undefined, {
    name: 'AIChatBotWidget__ConversationHeader',
    styles,
    classNames,
  })
  return (
    <Box className={cx(classes.root, className)} {...boxProps}>
      <Box className={classes.info}>
        <AvatarFocus />
        {React.cloneElement(headingTag, {
          size: 's3',
          className: classes.name,
          children: name,
        })}
      </Box>
      {onClose && (
        <Button
          color="#EA0029"
          leftIcon={<Close />}
          className={classes.closeBtn}
          onClick={() => onClose?.()}
        ></Button>
      )}
    </Box>
  )
}
